<div class="container-fluid mv2-root">
  <div class="row">
    <div class="col-lg-12" [style.padding]="'0'">
      <div class="pt-0 pl-2 pr-1 pb-5 mv2-frame" style="background-color: #fff !important;">
        <div class="row">
          <!-- Modo Visualizacao 2 -->
          <div class="col-12 mv2" [style.padding]="'0'">
            <header class="mv2-top">
              <button [style.color]="color" (mouseenter)="color = page.SITE.backgroundColorSliderSuperior"
                (mouseleave)="color = 'black'" type="button" class="mv2-back" (click)="page.voltarMv2()"
                aria-label="Voltar ao catálogo">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg> Catálogo
              </button>
              <div class="mv2-top-title">
                <!-- <p>Voltar ao catálogo</p> -->
                <!-- <strong>{{ page.product?.descricao }}</strong> -->
              </div>
              <button *ngIf="page.pedido" class="mv2-add btn-primary" type="submit" form="mv2-grade">
                <svg viewBox=" 0 0 24 24" aria-hidden="true">
                  <path d="M6 6h15l-1.5 9h-12z" fill="none" stroke="currentColor" stroke-width="2" />
                  <circle cx="9" cy="20" r="1.4" fill="currentColor" />
                  <circle cx="18" cy="20" r="1.4" fill="currentColor" />
                  <path d="M6 6L5 3H2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                </svg>
                <span>Adicionar {{ page.totalSelecionadoMv2 > 0 ? page.totalSelecionadoMv2 + " un." : "ao pedido"
                  }}</span>
              </button>
            </header>

            <div class="mv2-layout">
              <section class="mv2-gallery">
                <div class="mv2-photos">
                  <div class="mv2-thumbs-col">
                    <button type="button" class="mv2-nav" *ngIf="!mobile && page.fotosDaCor.length > page.fotosVisiveis"
                      aria-label="Fotos anteriores" [disabled]="page.fotoJanela === 0" (click)="page.moverFotos(-1)">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M6 14l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <div class="mv2-thumbs" [class.mv2-thumbs-center]="fotosSlider.length <= 4" #thumbsStrip
                      (pointerdown)="onThumbsPointerDown($event)" (pointermove)="onThumbsPointerMove($event)"
                      (pointerup)="onThumbsPointerUp()" (pointercancel)="onThumbsPointerUp()">
                      <button type="button" class="mv2-thumb"
                        *ngFor="let photo of fotosSlider; let visibleIndex = index"
                        [class.active]="fotoIndex(visibleIndex) === page.fotoAtiva"
                        (click)="onThumbClick($event, fotoIndex(visibleIndex))"
                        [attr.aria-label]="'Abrir foto ' + (fotoIndex(visibleIndex) + 1)">
                        <img [src]="photo.value" alt="" />
                        <span>{{ fotoIndex(visibleIndex) + 1 }}</span>
                      </button>
                    </div>
                    <button type="button" class="mv2-nav" *ngIf="!mobile && page.fotosDaCor.length > page.fotosVisiveis"
                      aria-label="Próximas fotos"
                      [disabled]="page.fotoJanela >= page.fotosDaCor.length - page.fotosVisiveis"
                      (click)="page.moverFotos(1)">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M6 10l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <span class="mv2-count">{{ page.fotoAtiva + 1 }} / {{ page.fotosDaCor.length }}</span>
                  </div>
                  <div class="mv2-main">
                    <a *ngIf="page.fotosDaCor[page.fotoAtiva] as foto" draggable="false"
                      (dragstart)="$event.preventDefault()" (click)="onPhotoClick(foto.value)">
                      <img [src]="foto.value" [alt]="page.product?.descricao" draggable="false" />
                      <!-- <div class="viewer">
                        <div #panzoom>
                          <img [src]="foto.value" [alt]="page.product?.descricao" draggable="false" />
                        </div>
                      </div> -->
                    </a>
                  </div>
                </div>

                <div class="mv2-info">
                  <div class="mv2-title-row">
                    <div>
                      <p class="mv2-ref"><span class="ref-label">Ref.</span>{{ page.product?.referencia }}</p>
                      <h1>{{ page.product?.descricao }}</h1>
                    </div>
                    <span *ngIf="!page.SITE?.mostraEstoqueDigitacao" class="mv2-badge"
                      [class.mv2-badge-off]="page.estoqueExibidoMv2 <= 0">
                      {{ page.estoqueExibidoMv2 }} em estoque
                    </span>
                  </div>
                  <p class="mv2-price" [style.color]="page.SITE.backgroundColorSliderSuperior"
                    *ngIf="page.pedido?.tabela && page.product?.tabelasPrecos && page.product?.tabelasPrecos[page.pedido.tabela.id] as tab">
                    <s *ngIf="tab.precoPromocional">{{ tab.preco | currency : "BRL" }}</s>
                    {{ (tab.precoPromocional || page.preco || tab.preco) | currency : "BRL" }}
                  </p>
                  <p class="mv2-lead" *ngIf="page.product?.observacoes">{{ page.product?.observacoes }}</p>
                </div>
              </section>

              <section class="mv2-grade">
                <div *ngIf="page.product?.ativo">
                  <div class="mv2-grade-head">
                    <div>
                      <h2>Grade de variações</h2>
                      <p>Informe a quantidade por cor e tamanho</p>
                      <div *ngIf="page.descontoPorItem == 1" class="mv2-desconto">
                        <label i18n>Desconto (%)</label>
                        <input [(ngModel)]="page.descontoPercent" class="form-control" />
                      </div>
                    </div>
                    <button [style.color]="SITE.backgroundColor" type="button" class="mv2-clear"
                      (click)="page.limparGrade()" [disabled]="page.totalSelecionadoMv2 === 0">
                      Limpar grade
                    </button>
                  </div>

                  <form id="mv2-grade" (ngSubmit)="page.onSubmit()" [formGroup]="page.form">
                    <div *ngFor="let est of page.estampas" class="mv2-estampa">
                      <p class="mv2-estampa-title" *ngIf="page.estampas.length > 1">
                        Estampa: {{ est.codigo }} - {{ est.descricao }}
                      </p>
                      <div class="mv2-grid-wrap">
                        <div class="mv2-grid mv2-grid-head" [style.grid-template-columns]="colunasGrade">
                          <span>Foto e cor</span>
                          <span *ngFor="let tam of page.tamanhos">{{ tam.tamanho }}</span>
                        </div>
                        <div class="mv2-grid" *ngFor="let cor of page.cores"
                          [class.mv2-grid-active]="page.corSelecionada && page.corSelecionada.cor == cor.id"
                          [style.grid-template-columns]="colunasGrade">
                          <button type="button" class="mv2-cor" (click)="page.selecionarCorMv2(cor.id)">
                            <img [src]="page.imagemDaCor(cor.id)" [alt]="cor.descricao" />
                            <span>
                              <strong>{{ cor.descricao }}</strong>
                              <small>Cor: {{ cor.descricao }} · {{ page.qtdFotosCor(cor.id) }} fotos</small>
                            </span>
                          </button>
                          <div *ngFor="let tam of page.tamanhos" class="mv2-cell">
                            <div *ngIf="page.pedido">
                              <div class="mv2-cell-inner"
                                [class.mv2-cell-inner-plain]="!page.SITE?.mostraEstoqueDigitacao" *ngVar="
                                cor.id +
                                '@' +
                                est.id +
                                '@' +
                                tam.tamanho +
                                '@' +
                                page.clienteSelecionado.id as IDFIELD
                              ">
                                <span class="mv2-size-label">{{ tam.tamanho }}</span>
                                <div class="mv2-stepper"
                                  [class.mv2-stepper-off]="page.skuBloqueado(cor.id, est.id, tam.tamanho)" role="group"
                                  [attr.aria-label]="'Quantidade ' + cor.descricao + ' ' + tam.tamanho">
                                  <button type="button" aria-label="Diminuir quantidade"
                                    [disabled]="page.skuBloqueado(cor.id, est.id, tam.tamanho)"
                                    (click)="page.decrement(IDFIELD)">
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                      <path d="M6 12h12" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" />
                                    </svg>
                                  </button>
                                  <input type="number" min="0" step="{{ page.multiplo }}" placeholder="0"
                                    formControlName="{{ IDFIELD }}" name="{{ IDFIELD }}"
                                    [class.mv2-zero]="!page.form.get(IDFIELD)?.value"
                                    [class.errorForm]="page.error && page.form.get(IDFIELD)?.invalid"
                                    [readOnly]="page.skuBloqueado(cor.id, est.id, tam.tamanho)"
                                    (input)="page.registrarDigitacao()" />
                                  <button type="button" aria-label="Aumentar quantidade"
                                    [disabled]="page.skuBloqueado(cor.id, est.id, tam.tamanho)"
                                    (click)="page.increment(IDFIELD)">
                                    <svg viewBox="0 0 24 24" aria-hidden="true">
                                      <path d="M12 6v12M6 12h12" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" />
                                    </svg>
                                  </button>
                                </div>
                                <span *ngIf="page.SITE?.mostraEstoqueDigitacao" class="mv2-stock mv2-stock-disp">
                                  Disponível: <strong>{{ page.quantidadeSku(cor.id, est.id, tam.tamanho) }}</strong>
                                </span>
                                <span *ngIf="page.SITE?.mostraEstoqueDigitacao"
                                  class="mv2-stock mv2-stock-mult">Múltiplo: <strong>{{ page.multiplo
                                    }}</strong></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="page.pedido && page.pedido.tipo.precoDivergente && page.corSelecionada"
                        class="mv2-divergente">
                        <div *ngFor="let tam of page.tamanhos" class="mv2-divergente-item">
                          <span class="mv2-divergente-tam">{{ tam.tamanho }}</span>
                          <span *ngIf="page.mostraPrecoMinimoVenda" class="mv2-min">
                            Mín. {{ page.precosDivergentes["min" + page.corSelecionada.cor + "@" + est.id + "@" +
                            tam.tamanho] }}
                          </span>
                          <span class="mv2-ideal">
                            Venda {{ page.precosDivergentes["ideal" + page.corSelecionada.cor + "@" + est.id + "@" +
                            tam.tamanho] }}
                          </span>
                          <input type="text"
                            [formControlName]="'precoDiv@' + page.corSelecionada.cor + '@' + est.id + '@' + tam.tamanho"
                            maxlength="14" onkeyup="mask(this, money);" onkeydown="mask(this, money);"
                            autocomplete="off" class="form-control precoMoney"
                            [class.errorForm]="page.error && page.form.get('precoDiv@' + page.corSelecionada.cor + '@' + est.id + '@' + tam.tamanho)?.invalid" />
                        </div>
                      </div>
                    </div>
                    <div class="mv2-total" [style.color]="page.SITE.backgroundColorSliderSuperior">
                      <span>Total selecionado</span>
                      <strong>{{ page.totalSelecionadoMv2 }} unidades · {{ page.totalSelecionadoMv2 * (page.preco || 0)
                        | currency : "BRL" }}</strong>
                    </div>
                    <button *ngIf="page.pedido" class="mv2-add mv2-add-end" type="submit"
                      [style.background]="page.SITE.backgroundColorSliderSuperior">
                      <svg viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M6 6h15l-1.5 9h-12z" fill="none" stroke="currentColor" stroke-width="2" />
                        <circle cx="9" cy="20" r="1.4" fill="currentColor" />
                        <circle cx="18" cy="20" r="1.4" fill="currentColor" />
                        <path d="M6 6L5 3H2" fill="none" stroke="currentColor" stroke-width="2"
                          stroke-linecap="round" />
                      </svg>
                      <span>Adicionar {{ page.totalSelecionadoMv2 > 0 ? page.totalSelecionadoMv2 + " un." : "ao pedido"
                        }}</span>
                    </button>
                  </form>

                  <div class="mv2-after">
                    <div class="mv2-specs" *ngIf="page.product?.fichaTecnica && page.product?.fichaTecnica.length">
                      <div *ngFor="let item of page.product.fichaTecnica" class="mv2-spec">
                        <p>{{ item.key }}</p>
                        <strong [innerHTML]="item.value"></strong>
                      </div>
                    </div>
                    <div class="mv2-desc" *ngIf="page.product?.observacoesSite || page.product?.observacoes">
                      <h2>Descrição</h2>
                      <simple-html *ngIf="page.product?.observacoesSite; else obsMv2"
                        [whiteSpace]="page.descr2WhiteSpace" [html]="page.product?.observacoesSite"></simple-html>
                      <ng-template #obsMv2>
                        <p>{{ page.product?.observacoes }}</p>
                      </ng-template>
                    </div>
                    <div class="mv2-detalhe" *ngIf="page.securityService.hasToken()">
                      <div *ngIf="page.SITE.mostraEstoqueDigitacao" class="grade">
                        <table class="table table-sm" style="margin-bottom: 10px">
                          <thead>
                            <tr>
                              <th i18n style="font-size: inherit">Estoque</th>
                            </tr>
                          </thead>
                        </table>
                        <div *ngFor="let fil of page.filiaisEstoqueDetalhe" style="border-top: 1px solid #dee2e6"
                          class="mb-3">
                          <div class="mb-1 grade-item-estampa float-left">
                            {{ fil.titulo }}
                          </div>
                          <div *ngFor="let est of page.product?.estampas">
                            <div i18n class="text-center mb-1 grade-item-estampa float-right">
                              Estampa: {{ est.codigo }} - {{ est.descricao }}
                            </div>
                            <table class="table table-hover table-sm table-striped mb-2">

                              <tr>
                                <th></th>
                                <th *ngFor="let tam of page.product?.tamanhos" style="text-align: center">
                                  {{ tam.tamanho }}
                                </th>
                              </tr>
                              <tbody>
                                <tr *ngFor="let cor of page.product?.cores">
                                  <td>{{ cor.codigo }} - {{ cor.descricao }}</td>
                                  <td *ngFor="let tam of page.tamanhos" class="text-center">
                                    {{
                                    page.getEstoqueSimpleString(
                                    cor.id,
                                    est.id,
                                    tam.tamanho,
                                    fil.id
                                    )
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="!page.SITE.mostraEstoqueDigitacao" class="row">
                        <div class="col-sm-6 mb-2">
                          <div *ngIf="page.product?.cores" class="table-responsive">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th i18n>Cores</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let cor of page.product?.cores">
                                  <td>{{ cor.descricao }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div *ngIf="page.product?.estampas" class="table-responsive">
                            <table class="table table-sm">
                              <thead>
                                <tr>
                                  <th i18n>Estampas</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let e of page.product?.estampas">
                                  <td>{{ e.descricao }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div *ngIf="page.product?.tamanhos" class="table-responsive">
                            <table class="table table-sm table-striped">
                              <thead>
                                <tr>
                                  <th i18n>Tamanhos</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let tam of page.product?.tamanhos">
                                  <td>{{ tam.tamanho }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <nav *ngIf="page.produtoAplicacaoContent || page.produtoCrossreferenceContent">
              <div class="nav nav-tabs" id="nav-tab-mv2" role="tablist">
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-aplicacao-mv2" role="tab"
                  aria-controls="nav-aplicacao-mv2" aria-selected="false" *ngIf="page.produtoAplicacaoContent" i18n>
                  Aplicação
                </a>
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-crossreference-mv2" role="tab"
                  aria-controls="nav-crossreference-mv2" aria-selected="false"
                  *ngIf="page.produtoCrossreferenceContent">
                  Cross Reference
                </a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent-mv2">
              <div *ngIf="false" class="tab-pane fade p-1" [style.margin-top]="page.descr2MarginTop + 'px'"
                id="nav-descricao" role="tabpanel" aria-labelledby="navDescricao">
                <div *ngIf="
                    page.product?.observacoesSite &&
                      page.product?.observacoesSite.length > page.descr2Limit;
                    else elseBlockObs
                  " style="overflow-x: auto" class="mb-4">
                  <div class="obsproduto2 mb-3 pl-1">
                    <div class="collapse mb-1" id="collapseObs" aria-expanded="false">
                      <simple-html [whiteSpace]="page.descr2WhiteSpace" [html]="page.product?.observacoesSite">
                        <slider-produto (redirectTo)="page.redirectTo.emit($event)" [values]="page.productsFeatured"
                          [title]="page.titleSliderProdutos" [dots]="page.dotsSliderProdutos"
                          [infinite]="page.infiniteSliderProdutos"
                          [interval]="page.intervalSliderProdutos"></slider-produto>
                      </simple-html>
                    </div>
                    <a role="button" id="btn-collapsed" class="collapsed mt-2 btn btn-outline-secondary btn-sm"
                      data-toggle="collapse" href="#collapseObs" aria-expanded="false" aria-controls="collapseObs"></a>
                  </div>
                </div>
                <ng-template #elseBlockObs>
                  <div class="mb-4">
                    <simple-html [whiteSpace]="page.descr2WhiteSpace" [html]="page.product?.observacoesSite">
                    </simple-html>
                  </div>
                </ng-template>
              </div>
              <div *ngIf="false" class="tab-pane fade p-1 mt-3" id="nav-imagens" role="tabpanel"
                aria-labelledby="navImagens">
                <div *ngIf="page.product?.imagens.length > 0" class="row">
                  <div *ngFor="let img of page.product?.imagens; let i = index" class="col-sm-3 mb-3">
                    <div class="card text-white {{
                        i == 0 ? 'bg-primary' : 'bg-secondary'
                      }}">
                      <div class="card-body">
                        <a id="ekkoLightbox" href="{{ page.API_IMAGENS_PRODUTOS }}{{ img.nome }}" data-toggle="lightbox"
                          data-gallery="example-gallery" data-title=" ">
                          <img src="{{ page.API_IMAGENS_PRODUTOS }}{{ img.nome }}" class="img-fluid" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="false" class="tab-pane fade p-1 mt-3" id="nav-ficha-mv2">


                <div class="table-responsive">
                  <table class="table table-sm">
                    <tbody>
                      <tr *ngFor="let item of page.product?.fichaTecnica">
                        <td>
                          <b>{{ item.key }}</b>
                        </td>
                        <td>{{ item.value }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div *ngIf="page.produtoAplicacaoContent" class="tab-pane fade p-1 mt-3" id="nav-aplicacao-mv2">
                <div [innerHTML]="page.produtoAplicacaoContent"></div>
              </div>
              <div *ngIf="page.produtoCrossreferenceContent" class="tab-pane fade p-1 mt-3" id="nav-crossreference-mv2">
                <div [innerHTML]="page.produtoCrossreferenceContent"></div>
              </div>
            </div>
            <a *ngIf="!page.securityService.hasToken()" routerLink="/login" role="button" id="btn-entrar"
              class="mt-2 ml-2 btn btn-outline-secondary btn-sm" i18n>
              Entrar
            </a>
          </div>
          <div id="slider-rec" class="col-12 col-md-12 col-lg-12">
            <slider-produto (redirectTo)="page.redirectTo.emit($event)" [autoplay]="false"
              [values]="page.produtosRelacionado" [title]="'Produtos Relacionados'"></slider-produto>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
<!-- 
      <div class="modal-header">
      </div> -->


      <div class="modal-body text-center p-0">

        <div class="viewer">
          <div #panzoom class="panzoom">
            <button type="button" class="close" (click)="fechaModal()" aria-label="Close">
              <span class="close-btn" aria-hidden="true">&times;</span>
            </button>
            <img [src]="imagemSelecionada" class="img-detail">
          </div>
        </div>
      </div>

    </div>
  </div>
</div>